export default "__VITE_ASSET__bf87f9a0__"